import store from "@/store";
export default {
  getPublicTags() {
    return ApiClient.get("api/bookables/public/_meta/tags");
  },
  getTags(tenant) {
    const t = tenant || store.getters["tenants/currentTenantId"];
    return ApiClient.get(`api/${t}/bookables/_meta/tags`, {
      withCredentials: true,
    });
  },
};
